import { createContext, useContext } from 'react'

// Create a context with default value of false for bleedToContainer
const ListContext = createContext({
  bleedToContainer: false,
})

// Custom hook to use the List context
export const useListContext = () => useContext(ListContext)

export default ListContext
